<page-headline
    [module]="'leads-partners'"
    [moduleIcon]="'fa-handshake'"
    [pageTitle]="'Leads & Partners Home'"
>
</page-headline>

<app-transition-directory-cards
    [applicationPage]="'leads-partners'"
></app-transition-directory-cards>
